import React from 'react';
// We don't need the context import if we're passing props
// import { useContext } from 'react';
// import { AdminContext } from '../context/AdminContext';

const PaginationNavigation = ({ totalPages, currentPage, movetoPage, goPrevPage, goNextPage }) => {
    
    // if(currentPage == 1){
    //     return <></>
    // }
    let pages = [];
    for(let i = 1; i <= totalPages; i++){
        pages.push(i);
    }

    return (
        // Added flex-wrap and gap-2. This will make the buttons
        // automatically wrap to the next line on small screens.
        <div className="flex justify-center items-center flex-wrap sm:flex-nowrap gap-2 sm:gap-3 mt-4">
            
            {/* --- Prev Button --- */}
            <button 
                onClick={goPrevPage}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-black text-white rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed disabled:text-gray-700 transition-colors"
                aria-label="Previous Page"
            >
                Prev
            </button>
            
            {/* --- Page Numbers --- */}
            {pages.map((page) => (
                <button 
                    key={page} 
                    onClick={() => movetoPage(page)} 
                    className={`px-4 py-2 rounded-md transition-colors font-medium ${
                        currentPage === page 
                        ? 'bg-black text-white' 
                        : 'bg-gray-200 text-black hover:bg-gray-300'
                    }`}
                    aria-current={currentPage === page ? 'page' : undefined}
                    aria-label={`Go to page ${page}`}
                >
                    {page}
                </button>
            ))}

            {/* --- Next Button --- */}
            <button 
                onClick={goNextPage}
                disabled={currentPage === totalPages}
                className="px-4 py-2 bg-black text-white rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed disabled:text-gray-700 transition-colors"
                aria-label="Next Page"
            >
                Next
            </button>
        </div>
    );
}

export default PaginationNavigation;

